function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.75,
    height: 17.29,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0170588235294118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 8.645,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.29,
    width: 28.75,
    height: 19.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.141764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 26.994999999999997,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.7,
    width: 28.75,
    height: 21.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 47.400000000000006,
    fontFamily: "Arial"
  }, "\n        Warwick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.11,
    width: 28.75,
    height: 22.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1852631578947368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 69.37,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.63,
    width: 28.75,
    height: 29.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 95.375,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.11,
    width: 28.75,
    height: 31.98,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.796875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 126.1,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.09,
    width: 28.75,
    height: 34.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6136363636363638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 159.32,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 176.56,
    width: 28.75,
    height: 36.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 194.91,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 213.26,
    width: 28.75,
    height: 40.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3958333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 233.54,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.82,
    width: 28.75,
    height: 44.92,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3958333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 276.28,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 298.74,
    width: 28.75,
    height: 45.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.369047619047619
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 321.26,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 343.78,
    width: 28.75,
    height: 49.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3958333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 368.59999999999997,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.42,
    width: 28.75,
    height: 49.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5972222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 418.365,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.32,
    width: 28.75,
    height: 50.27,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6911764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 468.455,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.58,
    width: 28.75,
    height: 50.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 518.715,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.85,
    width: 28.75,
    height: 50.64,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5972222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 569.1700000000001,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.49,
    width: 28.75,
    height: 50.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.796875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 619.9350000000001,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 645.38,
    width: 28.75,
    height: 54.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.513157894736842
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.375,
    y: 672.6899999999999,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 0,
    width: 37.26,
    height: 43.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.379999999999995,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 0,
    width: 37.42,
    height: 43.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9694736842105265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.71000000000001,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.42,
    y: 0,
    width: 37.75,
    height: 43.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7976190476190477
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.295,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Elizabeth_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.17,
    y: 0,
    width: 38.24,
    height: 43.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.186666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.29,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.41,
    y: 0,
    width: 38.98,
    height: 43.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0515789473684207
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.9,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.4,
    y: 0,
    width: 39.39,
    height: 43.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0300000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.095,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.79,
    y: 0,
    width: 40.46,
    height: 43.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6973333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.02000000000004,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.25,
    y: 0,
    width: 42.93,
    height: 43.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.715,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.18,
    y: 0,
    width: 43.09,
    height: 43.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.693125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.725,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.28,
    y: 0,
    width: 43.09,
    height: 43.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.693125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.825,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.37,
    y: 0,
    width: 43.18,
    height: 43.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8786666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.96,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.55,
    y: 0,
    width: 44.74,
    height: 43.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9536363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.92,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.29,
    y: 0,
    width: 45.48,
    height: 43.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.624166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.03,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.77,
    y: 0,
    width: 46.14,
    height: 43.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3453846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.84,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.9,
    y: 0,
    width: 46.55,
    height: 43.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.624166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.175,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.45,
    y: 0,
    width: 46.55,
    height: 43.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2889473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.725,
    y: 21.745,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 43.49,
    width: 47.32,
    height: 42.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.040952380952381
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 64.92,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 86.35,
    width: 47.32,
    height: 44.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.75875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 108.41999999999999,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 130.49,
    width: 47.32,
    height: 44.97,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6452941176470586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 152.97500000000002,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 175.46,
    width: 47.32,
    height: 45.5,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 198.21,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 220.96,
    width: 47.32,
    height: 46.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8800000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 244.24,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 267.52,
    width: 47.32,
    height: 46.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4505263157894737
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 290.79999999999995,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 314.08,
    width: 47.32,
    height: 47.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2495238095238097
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 337.7,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 361.32,
    width: 47.32,
    height: 47.47,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 385.055,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 408.78,
    width: 47.32,
    height: 47.62,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 432.59,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 456.4,
    width: 47.32,
    height: 47.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1546666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 480.28499999999997,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 504.17,
    width: 47.32,
    height: 47.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 528.09,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 552.01,
    width: 47.32,
    height: 48.37,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.783529411764706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 576.1949999999999,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 600.38,
    width: 47.32,
    height: 49.2,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 624.98,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 649.59,
    width: 47.32,
    height: 50.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.41,
    y: 674.7950000000001,
    fontFamily: "Arial"
  }, "\n        Nansemond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 43.49,
    width: 47.3,
    height: 50.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1533333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.72,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.37,
    y: 43.49,
    width: 47.58,
    height: 50.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.16,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.94,
    y: 43.49,
    width: 47.58,
    height: 50.89,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1719999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.73,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.52,
    y: 43.49,
    width: 49.34,
    height: 50.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5242857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.19,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.86,
    y: 43.49,
    width: 49.41,
    height: 50.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.565,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.26,
    y: 43.49,
    width: 51.58,
    height: 50.89,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6350000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.05,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.85,
    y: 43.49,
    width: 52.01,
    height: 50.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.914615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.855,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.85,
    y: 43.49,
    width: 53.69,
    height: 50.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.180625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.69500000000005,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.55,
    y: 43.49,
    width: 53.76,
    height: 50.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.914615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.43,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.31,
    y: 43.49,
    width: 56.86,
    height: 50.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.993529411764706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.7399999999999,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Alexandria_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.17,
    y: 43.49,
    width: 56.93,
    height: 50.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.993529411764706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.635,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.09,
    y: 43.49,
    width: 57.91,
    height: 50.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.914615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.0450000000001,
    y: 68.935,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 94.38,
    width: 58.86,
    height: 50.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3866666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 119.78,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 145.19,
    width: 58.86,
    height: 51.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.712105263157895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 170.95499999999998,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 196.72,
    width: 58.86,
    height: 52.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5126666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 223.065,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 249.4,
    width: 58.86,
    height: 53.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.686
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 276.26,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 303.12,
    width: 58.86,
    height: 53.84,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9911111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 330.04,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 356.96,
    width: 58.86,
    height: 54.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.193076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 384.215,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 411.47,
    width: 58.86,
    height: 55.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7106666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 439.3,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 467.14,
    width: 58.86,
    height: 55.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.486875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 495.03499999999997,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 522.92,
    width: 58.86,
    height: 58.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 552.06,
    fontFamily: "Arial"
  }, "\n        Princess_Anne_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 581.2,
    width: 58.86,
    height: 59.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.527692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 610.705,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 640.2,
    width: 58.86,
    height: 59.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.527692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 670.1,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 94.38,
    width: 56.45,
    height: 64.18,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.136111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.155,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.38,
    y: 94.38,
    width: 56.79,
    height: 64.18,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0564285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.775,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.17,
    y: 94.38,
    width: 58.62,
    height: 64.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.47999999999996,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 94.38,
    width: 60.69,
    height: 64.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.793125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.135,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.48,
    y: 94.38,
    width: 63.42,
    height: 64.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.228
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.19,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.89,
    y: 94.38,
    width: 65.48,
    height: 64.18,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5842857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.63,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.37,
    y: 94.38,
    width: 66.93,
    height: 64.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.278666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.835,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.3,
    y: 94.38,
    width: 67.88,
    height: 64.18,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.834545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.24,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.18,
    y: 94.38,
    width: 68.82,
    height: 64.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.01125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.5899999999999,
    y: 126.47,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 158.57,
    width: 68.76,
    height: 64.71,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.313999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 190.92499999999998,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 223.28,
    width: 68.76,
    height: 64.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.401666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 255.69,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 288.1,
    width: 68.76,
    height: 65.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.042307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 320.875,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 353.65,
    width: 68.76,
    height: 67.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 387.53999999999996,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 421.43,
    width: 68.76,
    height: 69.03,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8200000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 455.945,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 490.46,
    width: 68.76,
    height: 69.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.044705882352941
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 525.03,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 559.6,
    width: 68.76,
    height: 69.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.911428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 594.4,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.93,
    y: 629.2,
    width: 68.76,
    height: 70.8,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.31,
    y: 664.6,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 158.57,
    width: 67.45,
    height: 77.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.496666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.405,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.14,
    y: 158.57,
    width: 68.19,
    height: 77.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8707142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.235,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.33,
    y: 158.57,
    width: 68.79,
    height: 77.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.913571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.72499999999997,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.12,
    y: 158.57,
    width: 69.39,
    height: 77.47,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.336875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.815,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.51,
    y: 158.57,
    width: 73.69,
    height: 77.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.334705882352941
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.355,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.2,
    y: 158.57,
    width: 74.24,
    height: 77.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.32,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.44,
    y: 158.57,
    width: 74.56,
    height: 77.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.385882352941176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.72,
    y: 197.305,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 236.04,
    width: 83.69,
    height: 74.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 273.07,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 310.1,
    width: 83.69,
    height: 74.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.323571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 347.365,
    fontFamily: "Arial"
  }, "\n        Norfolk_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 384.64,
    width: 83.69,
    height: 75.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.397142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 422.41999999999996,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 460.2,
    width: 83.69,
    height: 78.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6049999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 499.435,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 538.67,
    width: 83.69,
    height: 78.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.617142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 577.99,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 617.3,
    width: 83.69,
    height: 82.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.513333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.525,
    y: 658.65,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.38,
    y: 236.04,
    width: 77.16,
    height: 91.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.511428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.96,
    y: 281.78999999999996,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.54,
    y: 236.04,
    width: 77.71,
    height: 91.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.550714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.39500000000004,
    y: 281.78999999999996,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.25,
    y: 236.04,
    width: 82.63,
    height: 91.5,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.508666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.565,
    y: 281.78999999999996,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.88,
    y: 236.04,
    width: 86.7,
    height: 91.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.23,
    y: 281.78999999999996,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.58,
    y: 236.04,
    width: 88.42,
    height: 91.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.894666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.7900000000001,
    y: 281.78999999999996,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.38,
    y: 327.54,
    width: 92.24,
    height: 89.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.989
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.5,
    y: 372.485,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.38,
    y: 417.43,
    width: 92.24,
    height: 93.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.5,
    y: 463.945,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.38,
    y: 510.46,
    width: 92.24,
    height: 94.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.854736842105263
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.5,
    y: 557.495,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.38,
    y: 604.53,
    width: 92.24,
    height: 95.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.149333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.5,
    y: 652.265,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.61,
    y: 327.54,
    width: 105.16,
    height: 84.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0249999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.19,
    y: 369.71500000000003,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.77,
    y: 327.54,
    width: 106.81,
    height: 84.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0249999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.175,
    y: 369.71500000000003,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.58,
    y: 327.54,
    width: 108.42,
    height: 84.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.961764705882352
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.7900000000001,
    y: 369.71500000000003,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.61,
    y: 411.9,
    width: 104.82,
    height: 93.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.493636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.02,
    y: 458.615,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.61,
    y: 505.33,
    width: 104.82,
    height: 93.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.02,
    y: 552.13,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.61,
    y: 598.93,
    width: 104.82,
    height: 101.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.02,
    y: 649.4649999999999,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.43,
    y: 411.9,
    width: 105.78,
    height: 108,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.222352941176471
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.32,
    y: 465.9,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.21,
    y: 411.9,
    width: 109.79,
    height: 108,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.352941176470588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.105,
    y: 465.9,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.43,
    y: 519.89,
    width: 83.96,
    height: 180.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.996666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.41,
    y: 609.9449999999999,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.39,
    y: 519.89,
    width: 131.61,
    height: 180.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.123846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.1949999999999,
    y: 609.9449999999999,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.0f363fdf106305e9b3c97508ed53790b.svg";
export { ForwardRef as ReactComponent };